import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';

const PILLARS = [
  {
    num: '01',
    title: 'Efficient Water Management',
    desc: 'Advanced drip irrigation and water recycling systems minimize waste while delivering optimal hydration to every plant.',
  },
  {
    num: '02',
    title: 'Reduced Chemical Inputs',
    desc: 'Integrated pest management and biological controls significantly reduce reliance on synthetic pesticides and herbicides.',
  },
  {
    num: '03',
    title: 'Soil Health Preservation',
    desc: 'Responsible cultivation practices maintain soil biodiversity, organic matter, and long-term land productivity.',
  },
  {
    num: '04',
    title: 'Sustainable Resource Stewardship',
    desc: 'Every operation is designed around minimizing our environmental footprint and maximizing resource efficiency.',
  },
];

export default function Sustainability({ dark }) {
  const ref = useFadeIn();

  return (
    <section id="sustainability" className={`py-24 px-6 ${dark ? 'bg-green-900/20' : 'bg-green-50/60'}`}>
      <div className="max-w-6xl mx-auto" ref={ref}>
        <div className="text-center mb-14 fade-in">
          <span className={`inline-block text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-5
            ${dark ? 'bg-green-400/10 text-green-400' : 'bg-green-100 text-green-800'}`}>
            Our Commitment
          </span>
          <h2 className={`font-serif text-3xl md:text-4xl font-bold leading-tight max-w-xl mx-auto mb-4 ${dark ? 'text-white' : 'text-green-900'}`}>
            Sustainability at Our Core
          </h2>
          <p className={`text-base leading-relaxed max-w-lg mx-auto ${dark ? 'text-green-300/60' : 'text-green-700/70'}`}>
            Dedicated to environmentally responsible farming that ensures long-term productivity and environmental protection for future generations.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {PILLARS.map(p => (
            <div key={p.num}
              className={`fade-in flex gap-5 items-start border rounded-2xl p-8 transition-all duration-300
                ${dark
                  ? 'bg-green-900/20 border-green-400/10 hover:border-green-600/30 hover:shadow-lg'
                  : 'bg-white border-green-800/10 hover:border-green-600 hover:shadow-xl'}`}
            >
              <div className={`font-serif text-4xl font-bold leading-none flex-shrink-0 ${dark ? 'text-green-600' : 'text-green-600'}`}>
                {p.num}
              </div>
              <div>
                <h3 className={`text-base font-semibold mb-2 ${dark ? 'text-white' : 'text-green-900'}`}>{p.title}</h3>
                <p className={`text-sm leading-relaxed ${dark ? 'text-green-300/60' : 'text-green-700/70'}`}>{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
